/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import * as import0 from '../../../../app/subapps/grid-memory/grid-memory.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../app/subapps/grid-memory/grid-memory.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from './grid-memory.component.css.shim';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import13 from '../../../../app/spinner/my-spinner.component';
import * as import14 from '../../spinner/my-spinner.component.ngfactory';
import * as import15 from '@angular/core/src/change_detection/change_detection_util';
import * as import16 from '@angular/core/src/linker/template_ref';
import * as import17 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import18 from '@angular/common/src/directives/ng_for';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import20 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import21 from '@angular/core/src/linker/element_ref';
import * as import22 from '@angular/common/src/directives/ng_class';
import * as import23 from '@angular/core/src/security';
export var Wrapper_GridMemoryComponent = (function () {
    function Wrapper_GridMemoryComponent(p0) {
        this._changed = false;
        this.context = new import0.GridMemoryComponent(p0);
    }
    Wrapper_GridMemoryComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_GridMemoryComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_GridMemoryComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_GridMemoryComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_GridMemoryComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_GridMemoryComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_GridMemoryComponent;
}());
var renderType_GridMemoryComponent_Host = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, [], {});
var View_GridMemoryComponent_Host0 = (function (_super) {
    __extends(View_GridMemoryComponent_Host0, _super);
    function View_GridMemoryComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_GridMemoryComponent_Host0, renderType_GridMemoryComponent_Host, import6.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways);
    }
    View_GridMemoryComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'my-grid-memory', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_GridMemoryComponent0(this.viewUtils, this, 0, this._el_0);
        this._GridMemoryService_0_3 = new import5.GridMemoryService(this.injectorGet(import9.Http, this.parentIndex));
        this._GridMemoryComponent_0_4 = new Wrapper_GridMemoryComponent(this._GridMemoryService_0_3);
        this.compView_0.create(this._GridMemoryComponent_0_4.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import8.ComponentRef_(0, this, this._el_0, this._GridMemoryComponent_0_4.context);
    };
    View_GridMemoryComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import5.GridMemoryService) && (0 === requestNodeIndex))) {
            return this._GridMemoryService_0_3;
        }
        if (((token === import0.GridMemoryComponent) && (0 === requestNodeIndex))) {
            return this._GridMemoryComponent_0_4.context;
        }
        return notFoundResult;
    };
    View_GridMemoryComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._GridMemoryComponent_0_4.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.detectChanges(throwOnChange);
    };
    View_GridMemoryComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_GridMemoryComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_GridMemoryComponent_Host0;
}(import1.AppView));
export var GridMemoryComponentNgFactory = new import8.ComponentFactory('my-grid-memory', View_GridMemoryComponent_Host0, import0.GridMemoryComponent);
var styles_GridMemoryComponent = [import10.styles];
var renderType_GridMemoryComponent = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.Emulated, styles_GridMemoryComponent, {});
export var View_GridMemoryComponent0 = (function (_super) {
    __extends(View_GridMemoryComponent0, _super);
    function View_GridMemoryComponent0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_GridMemoryComponent0, renderType_GridMemoryComponent, import6.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways);
        this._expr_63 = import15.UNINITIALIZED;
        this._expr_64 = import15.UNINITIALIZED;
        this._expr_65 = import15.UNINITIALIZED;
    }
    View_GridMemoryComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'div', new import3.InlineArray2(2, 'class', 'container'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'table', new import3.InlineArray2(2, 'style', 'width: 100%;'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import3.createRenderElement(this.renderer, this._el_2, 'tbody', import3.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, '\n        ', null);
        this._el_6 = import3.createRenderElement(this.renderer, this._el_4, 'tr', import3.EMPTY_INLINE_ARRAY, null);
        this._text_7 = this.renderer.createText(this._el_6, '\n            ', null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_6, 'td', new import3.InlineArray2(2, 'colspan', '2'), null);
        this._text_9 = this.renderer.createText(this._el_8, '\n                ', null);
        this._el_10 = import3.createRenderElement(this.renderer, this._el_8, 'div', new import3.InlineArray2(2, 'class', 'container'), null);
        this._text_11 = this.renderer.createText(this._el_10, '\n                    ', null);
        this._el_12 = import3.createRenderElement(this.renderer, this._el_10, 'button', new import3.InlineArray2(2, 'class', 'btn btn-sm btn-default'), null);
        this._text_13 = this.renderer.createText(this._el_12, '\n                        ', null);
        this._el_14 = import3.createRenderElement(this.renderer, this._el_12, 'span', new import3.InlineArray2(2, 'class', 'glyphicon glyphicon-refresh'), null);
        this._text_15 = this.renderer.createText(this._el_12, '\n                    ', null);
        this._text_16 = this.renderer.createText(this._el_10, '\n                    ', null);
        this._el_17 = import3.createRenderElement(this.renderer, this._el_10, 'span', new import3.InlineArray2(2, 'class', 'text-primary'), null);
        this._text_18 = this.renderer.createText(this._el_17, '', null);
        this._text_19 = this.renderer.createText(this._el_10, '\n                ', null);
        this._text_20 = this.renderer.createText(this._el_8, '\n            ', null);
        this._text_21 = this.renderer.createText(this._el_6, '\n        ', null);
        this._text_22 = this.renderer.createText(this._el_4, '\n        ', null);
        this._el_23 = import3.createRenderElement(this.renderer, this._el_4, 'tr', import3.EMPTY_INLINE_ARRAY, null);
        this._text_24 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_25 = import3.createRenderElement(this.renderer, this._el_23, 'td', import3.EMPTY_INLINE_ARRAY, null);
        this._text_26 = this.renderer.createText(this._el_25, '\n                ', null);
        this._anchor_27 = this.renderer.createTemplateAnchor(this._el_25, null);
        this._vc_27 = new import11.ViewContainer(27, 25, this, this._anchor_27);
        this._TemplateRef_27_5 = new import16.TemplateRef_(this, 27, this._anchor_27);
        this._NgFor_27_6 = new import12.Wrapper_NgFor(this._vc_27.vcRef, this._TemplateRef_27_5, this.parentView.injectorGet(import17.IterableDiffers, this.parentIndex), this.ref);
        this._text_28 = this.renderer.createText(this._el_25, '\n            ', null);
        this._text_29 = this.renderer.createText(this._el_23, '\n            ', null);
        this._el_30 = import3.createRenderElement(this.renderer, this._el_23, 'td', new import3.InlineArray8(6, 'class', 'media-right ', 'rowspan', '2', 'style', 'width: 75px;'), null);
        this._text_31 = this.renderer.createText(this._el_30, '\n                ', null);
        this._el_32 = import3.createRenderElement(this.renderer, this._el_30, 'div', new import3.InlineArray4(4, 'class', 'btn-group-vertical center-block', 'role', 'group'), null);
        this._text_33 = this.renderer.createText(this._el_32, '\n                    ', null);
        this._el_34 = import3.createRenderElement(this.renderer, this._el_32, 'button', new import3.InlineArray2(2, 'class', 'btn btn-sm btn-success disabled'), null);
        this._text_35 = this.renderer.createText(this._el_34, '\n                        ', null);
        this._el_36 = import3.createRenderElement(this.renderer, this._el_34, 'span', new import3.InlineArray2(2, 'class', 'label label-success badge'), null);
        this._text_37 = this.renderer.createText(this._el_36, '', null);
        this._text_38 = this.renderer.createText(this._el_34, '\n                    ', null);
        this._text_39 = this.renderer.createText(this._el_32, '\n                    ', null);
        this._el_40 = import3.createRenderElement(this.renderer, this._el_32, 'button', new import3.InlineArray2(2, 'class', 'btn btn-sm btn-danger disabled'), null);
        this._text_41 = this.renderer.createText(this._el_40, '\n                        ', null);
        this._el_42 = import3.createRenderElement(this.renderer, this._el_40, 'span', new import3.InlineArray2(2, 'class', 'label label-danger badge'), null);
        this._text_43 = this.renderer.createText(this._el_42, '', null);
        this._text_44 = this.renderer.createText(this._el_40, '\n                    ', null);
        this._text_45 = this.renderer.createText(this._el_32, '\n                ', null);
        this._text_46 = this.renderer.createText(this._el_30, '\n                ', null);
        this._el_47 = import3.createRenderElement(this.renderer, this._el_30, 'div', new import3.InlineArray4(4, 'bdgClass', 'glyphicon-th', 'mySpinner', ''), null);
        this.compView_47 = new import14.View_MySpinner0(this.viewUtils, this, 47, this._el_47);
        this._MySpinner_47_3 = new import14.Wrapper_MySpinner();
        this.compView_47.create(this._MySpinner_47_3.context);
        this._text_48 = this.renderer.createText(this._el_30, '\n                ', null);
        this._el_49 = import3.createRenderElement(this.renderer, this._el_30, 'div', new import3.InlineArray4(4, 'bdgClass', 'glyphicon-time', 'mySpinner', ''), null);
        this.compView_49 = new import14.View_MySpinner0(this.viewUtils, this, 49, this._el_49);
        this._MySpinner_49_3 = new import14.Wrapper_MySpinner();
        this.compView_49.create(this._MySpinner_49_3.context);
        this._text_50 = this.renderer.createText(this._el_30, '\n                ', null);
        this._text_51 = this.renderer.createText(this._el_30, '\n            ', null);
        this._text_52 = this.renderer.createText(this._el_23, '\n        ', null);
        this._text_53 = this.renderer.createText(this._el_4, '\n        ', null);
        this._text_54 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_55 = this.renderer.createText(this._el_0, '\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_12, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_12));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_47, new import3.InlineArray2(2, 'counterChange', null), this.eventHandler(this.handleEvent_47));
        this._MySpinner_47_3.subscribe(this, this.eventHandler(this.handleEvent_47), true);
        var disposable_2 = import3.subscribeToRenderElement(this, this._el_49, new import3.InlineArray2(2, 'counterChange', null), this.eventHandler(this.handleEvent_49));
        this._MySpinner_49_3.subscribe(this, this.eventHandler(this.handleEvent_49), true);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._el_10,
            this._text_11,
            this._el_12,
            this._text_13,
            this._el_14,
            this._text_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20,
            this._text_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._el_25,
            this._text_26,
            this._anchor_27,
            this._text_28,
            this._text_29,
            this._el_30,
            this._text_31,
            this._el_32,
            this._text_33,
            this._el_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._text_38,
            this._text_39,
            this._el_40,
            this._text_41,
            this._el_42,
            this._text_43,
            this._text_44,
            this._text_45,
            this._text_46,
            this._el_47,
            this._text_48,
            this._el_49,
            this._text_50,
            this._text_51,
            this._text_52,
            this._text_53,
            this._text_54,
            this._text_55
        ]), [
            disposable_0,
            disposable_1,
            disposable_2
        ]);
        return null;
    };
    View_GridMemoryComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import16.TemplateRef) && (27 === requestNodeIndex))) {
            return this._TemplateRef_27_5;
        }
        if (((token === import18.NgFor) && (27 === requestNodeIndex))) {
            return this._NgFor_27_6.context;
        }
        if (((token === import13.MySpinner) && (47 === requestNodeIndex))) {
            return this._MySpinner_47_3.context;
        }
        if (((token === import13.MySpinner) && (49 === requestNodeIndex))) {
            return this._MySpinner_49_3.context;
        }
        return notFoundResult;
    };
    View_GridMemoryComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_27_0_0 = this.context.files;
        this._NgFor_27_6.check_ngForOf(currVal_27_0_0, throwOnChange, false);
        this._NgFor_27_6.ngDoCheck(this, this._anchor_27, throwOnChange);
        var currVal_47_0_0 = this.context.limit;
        this._MySpinner_47_3.check_counterValue(currVal_47_0_0, throwOnChange, false);
        var currVal_47_0_1 = 'glyphicon-th';
        this._MySpinner_47_3.check_bdgClass(currVal_47_0_1, throwOnChange, false);
        this._MySpinner_47_3.ngDoCheck(this, this._el_47, throwOnChange);
        var currVal_49_0_0 = this.context.seconds;
        this._MySpinner_49_3.check_counterValue(currVal_49_0_0, throwOnChange, false);
        var currVal_49_0_1 = 'glyphicon-time';
        this._MySpinner_49_3.check_bdgClass(currVal_49_0_1, throwOnChange, false);
        this._MySpinner_49_3.ngDoCheck(this, this._el_49, throwOnChange);
        this._vc_27.detectChangesInNestedViews(throwOnChange);
        var currVal_63 = import3.inlineInterpolate(1, '', this.context.question, '');
        if (import3.checkBinding(throwOnChange, this._expr_63, currVal_63)) {
            this.renderer.setText(this._text_18, currVal_63);
            this._expr_63 = currVal_63;
        }
        var currVal_64 = import3.inlineInterpolate(1, '', this.context.countSuc, '');
        if (import3.checkBinding(throwOnChange, this._expr_64, currVal_64)) {
            this.renderer.setText(this._text_37, currVal_64);
            this._expr_64 = currVal_64;
        }
        var currVal_65 = import3.inlineInterpolate(1, '', this.context.countErr, '');
        if (import3.checkBinding(throwOnChange, this._expr_65, currVal_65)) {
            this.renderer.setText(this._text_43, currVal_65);
            this._expr_65 = currVal_65;
        }
        this.compView_47.detectChanges(throwOnChange);
        this.compView_49.detectChanges(throwOnChange);
    };
    View_GridMemoryComponent0.prototype.destroyInternal = function () {
        this._vc_27.destroyNestedViews();
        this.compView_47.destroy();
        this.compView_49.destroy();
        this._MySpinner_47_3.ngOnDestroy();
        this._MySpinner_49_3.ngOnDestroy();
    };
    View_GridMemoryComponent0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 27)) {
            return new View_GridMemoryComponent1(this.viewUtils, this, 27, this._anchor_27, this._vc_27);
        }
        return null;
    };
    View_GridMemoryComponent0.prototype.handleEvent_12 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context.onClickReload() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_GridMemoryComponent0.prototype.handleEvent_47 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'counterChange')) {
            var pd_sub_0 = (this.context.onChangeLimit($event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_GridMemoryComponent0.prototype.handleEvent_49 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'counterChange')) {
            var pd_sub_0 = (this.context.onChangeTimeout($event) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_GridMemoryComponent0;
}(import1.AppView));
var View_GridMemoryComponent1 = (function (_super) {
    __extends(View_GridMemoryComponent1, _super);
    function View_GridMemoryComponent1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        _super.call(this, View_GridMemoryComponent1, renderType_GridMemoryComponent, import6.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways, declaredViewContainer);
        this._map_26 = import3.pureProxy1(function (p0) {
            return { hidden: p0 };
        });
        this._map_27 = import3.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_28 = import15.UNINITIALIZED;
        this._expr_29 = import15.UNINITIALIZED;
        this._expr_30 = import15.UNINITIALIZED;
        this._expr_31 = import15.UNINITIALIZED;
        this._map_32 = import3.pureProxy1(function (p0) {
            return { hidden: p0 };
        });
        this._map_33 = import3.pureProxy1(function (p0) {
            return { active: p0 };
        });
        this._expr_34 = import15.UNINITIALIZED;
        this._expr_35 = import15.UNINITIALIZED;
    }
    View_GridMemoryComponent1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'div', new import3.InlineArray4(4, 'class', 'carousel slide card', 'data-ride', 'carousel'), null);
        this._NgClass_0_3 = new import19.Wrapper_NgClass(this.parentView.parentView.injectorGet(import17.IterableDiffers, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import20.KeyValueDiffers, this.parentView.parentIndex), new import21.ElementRef(this._el_0), this.renderer);
        this._text_1 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray4(4, 'class', 'carousel-inner  img-thumbnail face front', 'role', 'listbox'), null);
        this._NgClass_2_3 = new import19.Wrapper_NgClass(this.parentView.parentView.injectorGet(import17.IterableDiffers, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import20.KeyValueDiffers, this.parentView.parentIndex), new import21.ElementRef(this._el_2), this.renderer);
        this._text_3 = this.renderer.createText(this._el_2, '\n                        ', null);
        this._el_4 = import3.createRenderElement(this.renderer, this._el_2, 'div', new import3.InlineArray2(2, 'class', 'item'), null);
        this._NgClass_4_3 = new import19.Wrapper_NgClass(this.parentView.parentView.injectorGet(import17.IterableDiffers, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import20.KeyValueDiffers, this.parentView.parentIndex), new import21.ElementRef(this._el_4), this.renderer);
        this._text_5 = this.renderer.createText(this._el_4, '\n                            ', null);
        this._el_6 = import3.createRenderElement(this.renderer, this._el_4, 'img', new import3.InlineArray2(2, 'class', 'img-responsive'), null);
        this._text_7 = this.renderer.createText(this._el_4, '\n                            ', null);
        this._el_8 = import3.createRenderElement(this.renderer, this._el_4, 'div', new import3.InlineArray2(2, 'class', 'carousel-caption'), null);
        this._text_9 = this.renderer.createText(this._el_8, '', null);
        this._text_10 = this.renderer.createText(this._el_4, '\n                        ', null);
        this._text_11 = this.renderer.createText(this._el_2, '\n                    ', null);
        this._text_12 = this.renderer.createText(this._el_0, '\n                    ', null);
        this._el_13 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'carousel-inner img-thumbnail face back'), null);
        this._NgClass_13_3 = new import19.Wrapper_NgClass(this.parentView.parentView.injectorGet(import17.IterableDiffers, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import20.KeyValueDiffers, this.parentView.parentIndex), new import21.ElementRef(this._el_13), this.renderer);
        this._text_14 = this.renderer.createText(this._el_13, '\n                        ', null);
        this._el_15 = import3.createRenderElement(this.renderer, this._el_13, 'div', new import3.InlineArray2(2, 'class', 'item'), null);
        this._NgClass_15_3 = new import19.Wrapper_NgClass(this.parentView.parentView.injectorGet(import17.IterableDiffers, this.parentView.parentIndex), this.parentView.parentView.injectorGet(import20.KeyValueDiffers, this.parentView.parentIndex), new import21.ElementRef(this._el_15), this.renderer);
        this._text_16 = this.renderer.createText(this._el_15, '\n                            ', null);
        this._el_17 = import3.createRenderElement(this.renderer, this._el_15, 'img', new import3.InlineArray4(4, 'class', 'img-responsive', 'src', '/components/cover.jpg'), null);
        this._text_18 = this.renderer.createText(this._el_15, '\n                        ', null);
        this._text_19 = this.renderer.createText(this._el_13, '\n                    ', null);
        this._text_20 = this.renderer.createText(this._el_0, '\n                ', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray4(4, 'click', null, 'touch', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._el_6,
            this._text_7,
            this._el_8,
            this._text_9,
            this._text_10,
            this._text_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._el_17,
            this._text_18,
            this._text_19,
            this._text_20
        ]), [disposable_0]);
        return null;
    };
    View_GridMemoryComponent1.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import22.NgClass) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 10)))) {
            return this._NgClass_4_3.context;
        }
        if (((token === import22.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 11)))) {
            return this._NgClass_2_3.context;
        }
        if (((token === import22.NgClass) && ((15 <= requestNodeIndex) && (requestNodeIndex <= 18)))) {
            return this._NgClass_15_3.context;
        }
        if (((token === import22.NgClass) && ((13 <= requestNodeIndex) && (requestNodeIndex <= 19)))) {
            return this._NgClass_13_3.context;
        }
        if (((token === import22.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 20)))) {
            return this._NgClass_0_3.context;
        }
        return notFoundResult;
    };
    View_GridMemoryComponent1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = 'carousel slide card';
        this._NgClass_0_3.check_klass(currVal_0_0_0, throwOnChange, false);
        var currVal_0_0_1 = this.parentView.context.cardClasses;
        this._NgClass_0_3.check_ngClass(currVal_0_0_1, throwOnChange, false);
        this._NgClass_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = 'carousel-inner  img-thumbnail face front';
        this._NgClass_2_3.check_klass(currVal_2_0_0, throwOnChange, false);
        var currVal_2_0_1 = this._map_26(!this.context.$implicit.isFront);
        this._NgClass_2_3.check_ngClass(currVal_2_0_1, throwOnChange, false);
        this._NgClass_2_3.ngDoCheck(this, this._el_2, throwOnChange);
        var currVal_4_0_0 = 'item';
        this._NgClass_4_3.check_klass(currVal_4_0_0, throwOnChange, false);
        var currVal_4_0_1 = this._map_27(this.context.$implicit.isFront);
        this._NgClass_4_3.check_ngClass(currVal_4_0_1, throwOnChange, false);
        this._NgClass_4_3.ngDoCheck(this, this._el_4, throwOnChange);
        var currVal_13_0_0 = 'carousel-inner img-thumbnail face back';
        this._NgClass_13_3.check_klass(currVal_13_0_0, throwOnChange, false);
        var currVal_13_0_1 = this._map_32(this.context.$implicit.isFront);
        this._NgClass_13_3.check_ngClass(currVal_13_0_1, throwOnChange, false);
        this._NgClass_13_3.ngDoCheck(this, this._el_13, throwOnChange);
        var currVal_15_0_0 = 'item';
        this._NgClass_15_3.check_klass(currVal_15_0_0, throwOnChange, false);
        var currVal_15_0_1 = this._map_33(!this.context.$implicit.isFront);
        this._NgClass_15_3.check_ngClass(currVal_15_0_1, throwOnChange, false);
        this._NgClass_15_3.ngDoCheck(this, this._el_15, throwOnChange);
        var currVal_28 = this.context.$implicit.path;
        if (import3.checkBinding(throwOnChange, this._expr_28, currVal_28)) {
            this.renderer.setElementProperty(this._el_6, 'src', this.viewUtils.sanitizer.sanitize(import23.SecurityContext.URL, currVal_28));
            this._expr_28 = currVal_28;
        }
        var currVal_29 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_29, currVal_29)) {
            this.renderer.setElementProperty(this._el_6, 'alt', currVal_29);
            this._expr_29 = currVal_29;
        }
        var currVal_30 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_30, currVal_30)) {
            this.renderer.setElementProperty(this._el_6, 'title', currVal_30);
            this._expr_30 = currVal_30;
        }
        var currVal_31 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_31, currVal_31)) {
            this.renderer.setText(this._text_9, currVal_31);
            this._expr_31 = currVal_31;
        }
        var currVal_34 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_34, currVal_34)) {
            this.renderer.setElementProperty(this._el_17, 'alt', currVal_34);
            this._expr_34 = currVal_34;
        }
        var currVal_35 = import3.inlineInterpolate(1, '', this.context.$implicit.name, '');
        if (import3.checkBinding(throwOnChange, this._expr_35, currVal_35)) {
            this.renderer.setElementProperty(this._el_17, 'title', currVal_35);
            this._expr_35 = currVal_35;
        }
    };
    View_GridMemoryComponent1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_GridMemoryComponent1.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.parentView.context.flipCard(this.context.$implicit) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'touch')) {
            var pd_sub_1 = (this.parentView.context.flipCard(this.context.$implicit) !== false);
            result = (pd_sub_1 && result);
        }
        return result;
    };
    return View_GridMemoryComponent1;
}(import1.AppView));
//# sourceMappingURL=grid-memory.component.ngfactory.js.map